import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

const SchdeduleSyncActionCreationSchema = z.object({
  is_enabled: z.boolean().optional(),
  entity_id: z.string().optional(),
  action_type: z.string().optional(),
  cron: z.string().optional(),
  start_date: z.string().datetime().optional(),
  end_date: z.string().datetime().nullable().optional(),
  ui_state: z.any().optional(),
  content_type: z.any().optional(),
});

const SchdeduleSyncActionResponseSchema = z.object({
  id: z.number().int(),
  created_on: z.string().datetime(),
  updated_on: z.string().datetime(),
  deleted_on: z.string().datetime().nullable(),
  is_enabled: z.boolean(),
  entity_id: z.number().int().nullable(),
  action_type: z.string(),
  payload: z.any().nullable(),
  cron: z.string().nullable(),
  start_date: z.string().datetime(),
  end_date: z.string().datetime().nullable(),
  next_run: z.string().datetime().nullable(),
  last_run: z.string().datetime().nullable(),
  run_cnt: z.number().int(),
  ui_state: z.any().nullable(),
  created_by: z.any().nullable(),
  updated_by: z.any().nullable(),
  deleted_by: z.any().nullable(),
  org: z.number().int(),
  content_type: z.any().nullable(),
});

export const scheduleSyncActionsApiDefinitions = prefixApi(
  "/api/scheduled_sync_actions",
  apiBuilder({
    alias: "getScheduleSyncActions",
    method: "get",
    path: "/",
    status: 200,
    parameters: [
      {
        name: "page",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "entity_id",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "content_type",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "content_type__model",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    response: z.object({
      count: z.number(),
      next: z.string().nullable(),
      previous: z.string().nullable(),
      results: z.array(SchdeduleSyncActionResponseSchema),
    }),
  })
    .addEndpoint({
      alias: "createScheduleSyncAction",
      method: "post",
      path: "/",
      status: 201,
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: SchdeduleSyncActionCreationSchema,
        },
      ],
      response: z.object({
        ...SchdeduleSyncActionResponseSchema.shape,
      }),
    })
    .addEndpoint({
      alias: "updateScheduleSyncAction",
      method: "patch",
      path: "/:id/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            id: z.number().int(),
            ...SchdeduleSyncActionCreationSchema.shape,
          }),
        },
      ],
      response: z.object({
        ...SchdeduleSyncActionResponseSchema.shape,
      }),
    })
    .build(),
);
